import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { NotificationSoundType, SoundMode } from 'actions/notification/lib/notification_constants';

const SOUND_OFF = '';

export default class SetNotificationSoundMode {
  constructor(context) {
    this.context = context;
  }

  run({ mode }) {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.setCustomizeChannelNotificationSounds(mode === SoundMode.PER_CHANNEL);
    if (mode === SoundMode.BASIC) {
      preferences.setAgentNotificationSound(NotificationSoundType.AGENT_NOTIFICATION);
    } else if (mode === SoundMode.NONE) {
      preferences.setAgentNotificationSound(SOUND_OFF);
    }
    // PER_CHANNEL leaves agentNotificationSound untouched — per-channel sounds
    // are stored separately and the basic sound is restored if the agent switches back.
    setAgentPreferences(this.context, preferences);
  }
}
